var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hitchRidePricingRule"},[_c('custom-city-tree',{attrs:{"url":"/api/v1/manage/hitchRide/city"},on:{"city-selected":_vm.handleCitySelect}}),_c('div',{staticClass:"hitchRidePricingRule-content"},[_c('hitchRideForm',{attrs:{"cityData":{ ..._vm.selectCity }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }